export * from './global-popup.component';
export * from './global-popup.service';
